import axios from "axios";

const instance = axios.create({
  baseURL:
    "https://database-query.v3.microgen.id/api/v1/b577b7e2-5943-4b4d-b70d-9bb067b5a6b3",
});

export default instance;
